import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewVideoComponent} from './view-video/view-video.component';

const routes: Routes = [
  {
    path: ':id',
    children: [ {
        path: '',
        component: ViewVideoComponent
    }]
  },
  {
    path: '',
    children: [ {
        path: '',
        component: ViewVideoComponent
    }]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
